export default {
  text: 'Order directly from our site for fast service, to save on fees, earn free food, and help us save on delivery platform commissions',
  text_delivery: '<strong>Delivery & Pickup:</strong> Order directly from our site for fast service, earn free food, and help us save on delivery platform commissions',
};